import script from "./Relation.vue?vue&type=script&setup=true&lang=js"
export * from "./Relation.vue?vue&type=script&setup=true&lang=js"

import "./Relation.vue?vue&type=style&index=0&id=2143de2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2143de2e"]])

export default __exports__